import axios from 'axios'
import {BUSCAR_TIPOS_PERFIS, BUSCAR_USUARIOS, BUSCAR_USUARIOS_SISTEMA, BUSCAR_USUARIOS_VENDEDORES} from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';
import { montarURLFiltro } from '../../util/filtros';

export function buscarUsuarios (codigo, pagina, registrosPorPagina, filtros) {

  const urlFiltros = montarURLFiltro(filtros, pagina, registrosPorPagina);
  const url = `${URL}/usuarios/empresa/${codigo}${urlFiltros}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_USUARIOS,
        payload: response

      })
  );
}

export function buscarPerfis () {
  const url = `${URL}/usuarios/tipos-perfil`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: BUSCAR_TIPOS_PERFIS,
      payload: response
      
    })
  );
}

export function buscarUsuariosSistema (codigo, pagina, registrosPorPagina, filtros) {
  const urlFiltros = montarURLFiltro(filtros, pagina, registrosPorPagina);
  const url = `${URL}/usuarios/sistema/${urlFiltros}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: BUSCAR_USUARIOS_SISTEMA,
      payload: response
      
    })
  );
}

export function buscarUsuariosVendedores (idEmpresa) {  
  const url = `${URL}/usuarios-empresa/empresa/${idEmpresa}/usuarios-vendedores`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: BUSCAR_USUARIOS_VENDEDORES,
      payload: response
      
    })
  );
}

